// Tracking
import mixpanel from "mixpanel-browser";

const TITLES = {
  success: 'Sucesso',
  error: 'Atenção',
  warning: 'Aviso',
  information: 'Informação',
  info: 'Informação'
};

const SERVER_UNAVAILABLE_MESSAGE =
  'O sistema está temporariamente indisponível. Aguarde alguns instantes e tente novamente; se continuar, fale com o suporte.';

const TIMEOUT_MESSAGE =
  'O sistema demorou para responder. Aguarde alguns instantes e confira se a ação foi concluída antes de tentar novamente.';

const REQUEST_FAILED_MESSAGE =
  'Não foi possível concluir a ação. Tente novamente; se continuar, fale com o suporte.';

const HTTP_STATUS_MESSAGES = {
  401: 'Sua sessão expirou. Entre novamente para continuar.',
  403: 'Seu usuário não tem permissão para esta ação. Peça o acesso ao administrador.',
  404: 'Esta função não foi encontrada. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
  413: 'O arquivo é maior que o limite de 10 MB. Reduza o tamanho (por exemplo, comprimindo o PDF ou a foto) e envie novamente.',
  429: 'Muitas tentativas em pouco tempo. Aguarde um minuto e tente novamente.',
  502: SERVER_UNAVAILABLE_MESSAGE,
  503: SERVER_UNAVAILABLE_MESSAGE,
  504: TIMEOUT_MESSAGE
};

/* Erro do axios sem mensagem do backend mostrava o texto técnico em inglês
   ("Request failed with status code 502"). */
function describeRequestError(error) {
  return HTTP_STATUS_MESSAGES[error?.response?.status] || REQUEST_FAILED_MESSAGE;
}

function toUserMessage(message) {
  if (!message?.isAxiosError) return message;

  return resolveErrorMessage(message, describeRequestError(message));
}

/**
 * Motivo do erro para o usuário: a `mensagem` do backend quando ela existe (já
 * vem com a referência para o suporte); senão, o texto da tela.
 * O interceptor da API rejeita com texto quando não há conexão — ele também vale.
 */
export function resolveErrorMessage(error, fallbackMessage) {
  const backendMessage = error?.response?.data?.mensagem;

  if (typeof backendMessage === 'string' && backendMessage.trim()) return backendMessage;

  if (typeof error === 'string' && error.trim()) return error;

  return fallbackMessage;
}

function showToast(vm, message, type) {
  const isObject = message && typeof message === 'object';
  const normalizedMessage = isObject && message.message ? message.message : message;
  const normalizedType = type || (isObject ? message.type : undefined) || 'information';
  const toastType = normalizedType === 'info' ? 'information' : normalizedType;
  mixpanel.track(normalizedType, { message: normalizedMessage });

  if (vm.$toast && typeof vm.$toast[toastType] === 'function') {
    const title = TITLES[toastType] || TITLES.information;
    vm.$toast[toastType](normalizedMessage, { title });
  }
}

const mixinMessage = {
  data() {
    return {};
  },
  methods: {
    sendMessage(message, type) {
      showToast(this, toUserMessage(message), type);
    },

    /* Erro de chamada ao backend: mostra o motivo que o backend mandou; sem
       resposta dele, o texto da tela. */
    sendErrorMessage(error, fallbackMessage) {
      const screenMessage = HTTP_STATUS_MESSAGES[error?.response?.status] || fallbackMessage;

      this.sendMessage(resolveErrorMessage(error, screenMessage), 'error');
    }
  }
};

export default mixinMessage;
